import { defineComponent, ref, watch } from "vue";
import RadioInput from "./component-library25.mjs";
import InputWrapper from "./component-library19.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "radio-group",
  props: {
    options: { type: Array, required: true },
    name: { type: String, required: true },
    value: { type: String, default: null },
    errorMessage: { type: String, default: void 0 },
    required: { type: Boolean },
    disabled: { type: Boolean },
    verticalXs: { type: Boolean },
    verticalSm: { type: Boolean },
    verticalMd: { type: Boolean },
    verticalLg: { type: Boolean }
  },
  emits: ["input"],
  setup(__props) {
    const props = __props;
    const inputValue = ref(props.value);
    watch(props, ({ value }) => {
      inputValue.value = value;
    });
    return { __sfc: true, props, inputValue, RadioInput, InputWrapper };
  }
});
export {
  _sfc_main as default
};
